module.exports = __webpack_public_path__ + "img/banner.f963c119.png";